import StatusGif from "entities/status-gif";
import CustomLink from "shared/ui/typography/CustomLink";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";

export const StandardOrderAppointmentCreated = () => {
  return (
    <div className="gg-mx-auto gg-max-w-3xl">
      <div className="gg-text-lg">
        <StatusGif
          src={`https://media1.giphy.com/media/ua4OxpbgAtItnS5hWu/giphy.gif`}
          alt="Een GewoonGers Gif. Een monteur springt uit zijn bus."
        />

        <Heading
          headingLevel="h1"
          className="gg-mb-3 md:gg-mb-10 md:gg-text-4xl lg:gg-text-7xl"
        >
          Bevestiging leveringsafspraak
        </Heading>

        <Text className="gg-mb-3 gg-text-xl md:gg-mb-5 md:gg-text-2xl">
          Bedankt, we hebben je voorkeur ontvangen! De afspraak staat bij ons in
          de agenda
        </Text>

        <Text className="gg-mb-3 md:gg-mb-5">
          2 dagen voor de afspraak (óók in het weekend) sturen we je rond 18.00
          uur een herinnering via de mail. Hierin staat de geplande leverdatum
          én een tijdsblok van 2 uur waarin je onze collega’s kunt verwachten.
          Op de dag van levering bellen wij ca. 30 minuten van tevoren.
        </Text>

        <p>
          Zorg ervoor dat er iemand aanwezig is op locatie om de bestelling in
          ontvangst te nemen én dat zijn/haar telefoonnummer bekend is bij ons.
        </p>

        <Text className="gg-mb-10">
          Heb je vragen of opmerkingen? Neem dan gerust even contact met ons op
          en houd je bevestigingsnummer of postcode bij de hand. Contact ons
          via:{" "}
          <CustomLink to="mailto:info@gewoongers.nl" opacityTransition={false}>
            info@gewoongers.nl
          </CustomLink>{" "}
          of{" "}
          <CustomLink to="tel:+310103072889" opacityTransition={false}>
            010 3072889
          </CustomLink>
          .
        </Text>
      </div>
    </div>
  );
};
